// removed by extract-text-webpack-plugin
module.exports = {"cover":"qI5wl3ECW0Eokte6G_jz1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Playlist/PlaylistAlbumCover/PlaylistAlbumCover.scss
// module id = 1290
// module chunks = 1